import { TabsItem } from './TabsItem';
import { TabsRoot } from './TabsRoot';

export const Tabs = {
  Root: TabsRoot,
  Item: TabsItem,
};
